import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getCookie, CookieName } from '@chegg/utils';
import { useMutation } from '@apollo/client';
import { SET_SUBSCRIPTION_AUTO_APPLOY_COUPON_CACHE } from '../gql/queries';
import { APOLLO_COMMERCE_CONTEXT } from '../gql/constants';
export var readCampaignCookie = function readCampaignCookie() {
  var cookieString = getCookie(CookieName.COUPON_CAMPAIGN);
  if (!cookieString) return null;
  try {
    var cookie = JSON.parse(cookieString);
    return cookie;
  } catch (e) {
    return null;
  }
};
var useCampaignCookie = function useCampaignCookie(options) {
  var _useMutation = useMutation(SET_SUBSCRIPTION_AUTO_APPLOY_COUPON_CACHE),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    mutateFunction = _useMutation2[0],
    _ = _useMutation2[1];
  return function (campaignCookie) {
    return mutateFunction(_objectSpread(_objectSpread({}, options), {}, {
      variables: _objectSpread(_objectSpread({}, options === null || options === void 0 ? void 0 : options.variables), {}, {
        couponCode: campaignCookie.couponCode || ''
      }),
      context: _defineProperty({}, APOLLO_COMMERCE_CONTEXT, true)
    }));
  };
};
export default useCampaignCookie;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/hooks/useCampaignCookie.js
// module id = 869
// module chunks = 11